import { inject } from '@angular/core';
import { Route, Router } from '@angular/router';
import { AuthComponent } from '@booking/auth.component';
import { authGuard } from '@core/guards/auth.guard';
import { AuthenticationService } from '@core/services/auth.service';
import { LandingComponent } from '@landing/landing.component';

export enum BannerTypes {
  INTERVU = 'intervu',
  VISION = 'vision',
  DASHBOARD = 'dashboard'
};
export type LeftBannerType = BannerTypes;

export type RouterLayoutData = {
  hideHeader?: boolean;
  leftBanner?: LeftBannerType;
  hideFooter?: boolean;
};

type RouteData = {
  data?: RouterLayoutData;
};
type RouteWithData = Route & RouteData;

export const rootRoutes: RouteWithData[] = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [() => { return !inject(AuthenticationService).isLogged() || (inject(Router).navigateByUrl('profile/dashboard'), false)}],
    component: LandingComponent
  },
  {
    path: 'authorize',
    pathMatch: 'full',
    component: AuthComponent,
    data: {
      leftBanner: BannerTypes.DASHBOARD
    },
  },
  {
    path: 'booking',
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('@booking/booking.component').then(x => x.BookingComponent),
      },
      {
        path: 'intervu/:serviceType',
        loadComponent: () => import('@booking/intervu/intervu.component').then(x => x.IntervuComponent),
        data: {
          leftBanner: BannerTypes.INTERVU
        },
      },
      {
        path: 'vision/:serviceType',
        loadComponent: () => import('@booking/vision/vision.component').then(x => x.VisionComponent),
        data: {
          leftBanner: BannerTypes.VISION
        },
      }
    ]
  },
  {
    path: 'profile',
    data: {
      leftBanner: BannerTypes.DASHBOARD
    },
    canMatch:[authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('@booking/dashboard/booking-dashboard/booking-dashboard.component').then(
            x => x.BookingDashboardComponent
          ),
      },
      {
        path: 'all-bookings',
        loadComponent: () =>
          import('@booking/dashboard/all-bookings/all-bookings.component').then(
            x => x.AllBookingsComponent
          ),
      },
      {
        path: 'booking-edit/:projectNo',
        loadComponent: () =>
          import('@booking/dashboard/booking-edit/booking-edit.component').then(
            x => x.BookingEditComponent
          ),
      },
    ]
  },
  {
    path: 'templates',
    data: {
      leftBanner: BannerTypes.DASHBOARD
    },
    canMatch:[authGuard],
    children: [
      {
        path: 'index',
        loadComponent: () =>
          import('@booking/dashboard/templates/templates.component').then(
            x => x.TemplatesComponent
          ),
      },
      {
        path: 'add',
        loadComponent: () =>
          import('@booking/dashboard/templates/add-template.component').then(
            x => x.AddTemplateComponent
          ),
      },
      {
        path: 'edit/:id',
        loadComponent: () =>
          import('@booking/dashboard/templates/edit-template.component').then(
            x => x.EditTemplateComponent
          ),
      },
    ]
  },
  // THIS IS TEMPORARY (for QA testing only)
  {
    path: 'thank-you',
    loadComponent: () =>
      import('@booking/thank-you-for-booking/thank-you-for-booking.component').then(x => x.ThankYouForBookingComponent),
    data: {
      hideHeader: true,
      hideFooter: true
    },
  },
  {
    path: '**',
    loadComponent: () => import('src/app/page-not-found/page-not-found.component').then(x => x.PageNotFoundComponent),
    data: {
      hideHeader: true,
      hideFooter: true
    },
  },
];
